@import 'styles/mixins';
@import 'styles/variables';

.header {
  @include line-clamp;
  @include lg-semibold;
  color: var(--neutral-90);
  margin: 6px 0px 0 8px;
  padding-left: 4px;
  padding-bottom: 6px;
  min-width: 195px;

  @include for-phone-only {
    border-bottom: 1px solid var(--neutral-5);
    margin-left: 4px;
  }
}

.optionsList {
  @include ui-md-semibold;
  display: flex;
  flex-direction: column;
  margin: 0 8px 34px 4px;
}
